import Grid from '@material-ui/core/Grid';
import { addViewOffer } from '@webapps/business';
import { useMutation } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

import InfoName from './InfoName';
import Informations from './Informations';

const Details = ({
  partnersAccepted,
  partnersRequested,
  partnersReceived,
  handleRefetch,
  accountInfos,
  info,
  closeModal,
  userInfo,
}) => {
  const { mutateAsync: mutateAddView } = useMutation(addViewOffer);
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);



  useEffect(() => {
    if (info?.id) {
      mutateAddView({
        id: info?.id,
      });
    }
  }, [info]);

  return (
    <>
      <InfoName
        partnersAccepted={partnersAccepted}
        partnersRequested={partnersRequested}
        partnersReceived={partnersReceived}
        handleRefetch={handleRefetch}
        accountInfos={accountInfos}
        info={info}
        closeModal={closeModal}
        userInfo={userInfo}
      />
      <Informations
        partnersAccepted={partnersAccepted}
        partnersRequested={partnersRequested}
        partnersReceived={partnersReceived}
        accountInfos={accountInfos}
        info={info}
        userInfo={userInfo}
      />
    </>
  );
};

Details.propTypes = {
  info: PropTypes.string,
};

const styles = ({ spacing }) => ({
  container: {
    
  },
});
export default Details;
